export default "__VITE_ASSET__ClX3NsTG__"